export const CHECKBOX_GROUP_SKELETON_ROWS_LENGTH = 9
